import { useApp } from "../../contexts/app.context";
import { useEffect, useState } from "react";

export function useRealtimeCalls() {
    const { socket } = useApp();
    const [calls, setCalls] = useState<any[]>([]);

    useEffect(() => {
        if(socket){
            socket.on("calls:update", (doc) => {
                setCalls((prev) => {
                    const exists = prev.find((c) => c.id === doc.id);
                    if (exists)
                        return prev.map((c) => (c.id === doc.id ? doc : c));
                    return [doc, ...prev];
                });
            });
    
            return () => { socket.off("calls:update"); }
        }
    }, [socket]);

    return { calls };
}
